import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {Helmet} from "react-helmet";
import './App.css';
import "cookieconsent";
import './CookieConsent.css';
import Cookie from "js-cookie";
import $ from "jquery";
import Clipboard from "react-clipboard.js";
import { ChromePicker } from 'react-color';

//Defenir links para ir buscar os ficheiros caso não baixe os assets
var url = "http://wmcookies.labs.wiremaze.com"
var linkcss = url + "/assets/css/CookieConsent.min.css"
var linkjs= url + "/assets/js/CookieConsentAPI.min.js"




//Variaveis para configuracao
var link="";
var TextoCustom = new Array();
TextoCustom[0]=""
TextoCustom[1]=""
TextoCustom[2]=""
TextoCustom[3]=""
var Settings = new Array();
Settings[1]=1
Settings[2]=1
Settings[3]=1
Settings[4]=false
Settings[5]=1
Settings[6]=false
var Cores= criarArray(18, 4)
// Cores
//0 - BG do popup
//1 - TXT do popup
//2 - BG do button
//3 - TXT do button

//criarPallete(index,BGpopup,TXTpopup,BGbutton,TXTbutton)
criarPalette(1,"#000","","#f1d600","")
criarPalette(2,"#eaf7f7","#5c7291","#56cbdb","#ffffff")
criarPalette(3,"#252e39","","#14a7d0","")
criarPalette(4,"#000","#0f0","#0f0","")
criarPalette(5,"#3937a3","","#e62576","")
criarPalette(6,"#64386b","#ffcdfd","#f8a8ff","#3f0045")
criarPalette(7,"#237afc","","#fff","#237afc")
criarPalette(8,"#aa0000","#ffdddd","#ff0000","")
criarPalette(17,"#FFFFFF","#000000","#000000","#FFFFFF")

//Demo das Palette's
function Demo(props) {
    return <div className={props.name + "master master"}><div className={props.name}/></div>;
}

class App extends Component {

  constructor(props) {
    super(props);
    this.state={selectedOption1: "1",
                selectedOption2: "1",
                selectedOption3: "1",
                selectedOption4: "false",
                selectedOption5: "1",
                selectedOption6: "false",
                CustomText1: "",
                CustomText2: "",
                CustomText3: "",
                CustomText4: "",
                Link: "",
                Color1:"#FFFFFF",
                Color2:"#000000",
                Color3:"#000000",
                Color4:"#FFFFFF",
                ColorPicker1:false,
                ColorPicker2:false,
                ColorPicker3:false,
                ColorPicker4:false
  };

    this.handleChange1= this.handleChange1.bind(this);
    this.handleChange2= this.handleChange2.bind(this);
    this.handleChange3= this.handleChange3.bind(this);
    this.handleChange4= this.handleChange4.bind(this);
    this.handleChange5= this.handleChange5.bind(this);
    this.handleChange6= this.handleChange6.bind(this);
    this.handleChangeLink= this.handleChangeLink.bind(this);
    this.handleChangeColor1= this.handleChangeColor1.bind(this);
    this.handleMChangeColor1= this.handleMChangeColor1.bind(this);
    this.handleChangeColor2= this.handleChangeColor2.bind(this);
    this.handleMChangeColor2= this.handleMChangeColor2.bind(this);
    this.handleChangeColor3= this.handleChangeColor3.bind(this);
    this.handleMChangeColor3= this.handleMChangeColor3.bind(this);
    this.handleChangeColor4= this.handleChangeColor4.bind(this);
    this.handleMChangeColor4= this.handleMChangeColor4.bind(this);
    this.handleChangeText1= this.handleChangeText1.bind(this);
    this.handleChangeText2= this.handleChangeText2.bind(this);
    this.handleChangeText3= this.handleChangeText3.bind(this);
    this.handleChangeText4= this.handleChangeText4.bind(this);
    this.handleFocus1= this.handleFocus1.bind(this);
    this.handleUnfocus1= this.handleUnfocus1.bind(this);
    this.handleFocus2= this.handleFocus2.bind(this);
    this.handleUnfocus2= this.handleUnfocus2.bind(this);
    this.handleFocus3= this.handleFocus3.bind(this);
    this.handleUnfocus3= this.handleUnfocus3.bind(this);
    this.handleFocus4= this.handleFocus4.bind(this);
    this.handleUnfocus4= this.handleUnfocus4.bind(this);
  }

  handleChange1(event) {
    this.setState({selectedOption1: event.target.value});
    Settings[1]=event.target.value;
    zAtualizar();
  }
  handleChange2(event) {
    this.setState({selectedOption2: event.target.value});
    Settings[2]=event.target.value;
    zAtualizar();
  }
  handleChange3(event) {
    this.setState({selectedOption3: event.target.value});
    Settings[3]=event.target.value;
    zAtualizar();
  }
  handleChange4(event) {
    this.setState({selectedOption4: event.target.value});
    Settings[4]=event.target.value;
    zAtualizar();
  }
  handleChange5(event) {
    this.setState({selectedOption5: event.target.value});
    Settings[5]=event.target.value;
    zAtualizar();
  }
  handleChange6(event) {
    var xyz;
    if(this.state.selectedOption6=="false") {
      xyz="true"
    } else
      if(this.state.selectedOption6=="true") {xyz="false"}
    this.setState({selectedOption6: xyz});
    Settings[6]=xyz
    zAtualizar();
  }
  handleChangeText1(event) {
    this.setState({CustomText1: event.target.value});
    TextoCustom[0]=event.target.value;
    zAtualizar();
  }
  handleChangeText2(event) {
    this.setState({CustomText2: event.target.value});
    TextoCustom[1]=event.target.value;
    zAtualizar();
  }
  handleChangeText3(event) {
    this.setState({CustomText3: event.target.value});
    TextoCustom[2]=event.target.value;
    zAtualizar();
  }
  handleChangeText4(event) {
    this.setState({CustomText4: event.target.value});
    TextoCustom[3]=event.target.value;
    zAtualizar();
  }
  handleChangeLink(event) {
    this.setState({Link: event.target.value});
    link=event.target.value;
    zAtualizar();
  }
  handleChangeColor1(color) {
    this.setState({Color1: color.hex});
    Cores[17][0]= color.hex
    zAtualizar();
  }
  handleMChangeColor1(event) {
    this.setState({Color1: event.target.value});
    Cores[17][0]=event.target.value;
    zAtualizar();
  }
  handleChangeColor2(color) {
    this.setState({Color2: color.hex});
    Cores[17][1]= color.hex
    zAtualizar();
  }
  handleMChangeColor2(event) {
    this.setState({Color2: event.target.value});
    Cores[17][1]= event.target.value
    zAtualizar();
  }
  handleChangeColor3(color) {
    this.setState({Color3: color.hex});
    Cores[17][2]= color.hex
    zAtualizar();
  }
  handleMChangeColor3(event) {
    this.setState({Color3: event.target.value});
    Cores[17][2]= event.target.value
    zAtualizar();
  }
  handleChangeColor4(color) {
    this.setState({Color4: color.hex});
    Cores[17][3]= color.hex
    zAtualizar();
  }
  handleMChangeColor4(event) {
    this.setState({Color3: event.target.value});
    Cores[17][3]= event.target.value
    zAtualizar();
  }
  handleFocus1(event) {
    this.setState({ColorPicker1: true});
  }
  handleUnfocus1(event) {
    this.setState({ColorPicker1: false});
  }
  handleFocus2(event) {
    this.setState({ColorPicker2: true});
  }
  handleUnfocus2(event) {
    this.setState({ColorPicker2: false});
  }
  handleFocus3(event) {
    this.setState({ColorPicker3: true});
  }
  handleUnfocus3(event) {
    this.setState({ColorPicker3: false});
  }
  handleFocus4(event) {
    this.setState({ColorPicker4: true});
  }
  handleUnfocus4(event) {
    this.setState({ColorPicker4: false});
  }

  render() {
    return (
      <div>
        <div id="sandbox"/>
        <Helmet>



        </Helmet>
      <div className="geral">
        <div className="container">
        <div className="containerhead">
          <div className="headcat" id="head1"><div className="numcat">1</div>Posicionamento</div>
            <div className="conteudo cradio" id="cont1">
              <label className="iradio"><input type="radio" value="1" checked={this.state.selectedOption1 === '1'} onChange={this.handleChange1}/><span>Banner Bottom</span></label>
              <label className="iradio"><input type="radio" value="2" checked={this.state.selectedOption1 === '2'} onChange={this.handleChange1}/><span>Floating left</span></label>
              <label className="iradio"><input type="radio" value="3" checked={this.state.selectedOption1 === '3'} onChange={this.handleChange1}/><span>Banner Top</span></label>
              <label className="iradio"><input type="radio" value="4" checked={this.state.selectedOption1 === '4'} onChange={this.handleChange1}/><span>Floating right</span></label>
              <label className="iradio"><input type="radio" value="5" checked={this.state.selectedOption1 === '5'} onChange={this.handleChange1}/><span>Banner top (pushdown)</span></label>
            </div>
        </div>
        <div className="containerhead">
          <div className="headcat" id="head2"><div className="numcat">2</div>Layout</div>
            <div className="conteudo cradio" id="cont2">
              <label className="iradio"><input type="radio" value="1" checked={this.state.selectedOption2 === '1'} onChange={this.handleChange2}/><span>Block</span></label>
              <label className="iradio"><input type="radio" value="2" checked={this.state.selectedOption2 === '2'} onChange={this.handleChange2}/><span>Edgeless</span></label>
              <label className="iradio"><input type="radio" value="3" checked={this.state.selectedOption2 === '3'} onChange={this.handleChange2}/><span>Classic</span></label>
              <label className="iradio"><input type="radio" value="4" checked={this.state.selectedOption2 === '4'} onChange={this.handleChange2}/><span>Wire</span></label>
            </div>
        </div>
        <div className="containerhead">
          <div className="headcat" id="head3"><div className="numcat">3</div>Palete de cores</div>
            <div className="conteudo cradio" id="cont3">
              <div className="areacustom"><strong>Temas</strong></div>
              <label className="iradio palette"><input type="radio" value="1" checked={this.state.selectedOption3 === '1'} onChange={this.handleChange3}/><Demo name="a"/></label>
              <label className="iradio palette"><input type="radio" value="2" checked={this.state.selectedOption3 === '2'} onChange={this.handleChange3}/><Demo name="b"/></label>
              <label className="iradio palette"><input type="radio" value="3" checked={this.state.selectedOption3 === '3'} onChange={this.handleChange3}/><Demo name="c"/></label>
              <label className="iradio palette"><input type="radio" value="4" checked={this.state.selectedOption3 === '4'} onChange={this.handleChange3}/><Demo name="d"/></label>
              <label className="iradio palette"><input type="radio" value="5" checked={this.state.selectedOption3 === '5'} onChange={this.handleChange3}/><Demo name="e"/></label>
              <label className="iradio palette"><input type="radio" value="6" checked={this.state.selectedOption3 === '6'} onChange={this.handleChange3}/><Demo name="f"/></label>
              <label className="iradio palette"><input type="radio" value="7" checked={this.state.selectedOption3 === '7'} onChange={this.handleChange3}/><Demo name="g"/></label>
              <label className="iradio palette"><input type="radio" value="8" checked={this.state.selectedOption3 === '8'} onChange={this.handleChange3}/><Demo name="h"/></label>
              <label className="iradio areacustom  cpoverflow">
                <input type="radio" value="17" checked={this.state.selectedOption3 === '17'} onChange={this.handleChange3}/>
                <span className="custom">Customizar cores</span>
                <div className="cp">

                    <div style={{display:this.state.ColorPicker1 ? "block" : "none"}} className="cover" onClick={this.handleUnfocus1}/>
                  <label className={this.state.ColorPicker1 ? "lblcp hl" : "lblcp"}>
                    Cor background popup:
                    <input type="text" value={this.state.Color1} onChange={this.handleMChangeColor1} onClick={this.handleFocus1}/>
                    <div style={{display:this.state.ColorPicker1 ? "block" : "none"}} className="colorpicker" >
                      <ChromePicker color={this.state.Color1} onChangeComplete={this.handleChangeColor1} disableAlpha={true} />
                    </div>
                  </label>

                    <div style={{display:this.state.ColorPicker2 ? "block" : "none"}} className="cover" onClick={this.handleUnfocus2}/>
                  <label className={this.state.ColorPicker2 ? "lblcp hl" : "lblcp"}>
                    Cor texto popup:
                    <input type="text" value={this.state.Color2} onChange={this.handleMChangeColor2} onClick={this.handleFocus2}/>
                    <div style={{display:this.state.ColorPicker2 ? "block" : "none"}} className="colorpicker">
                      <ChromePicker color={this.state.Color2} onChangeComplete={this.handleChangeColor2} disableAlpha={true} />
                    </div>
                  </label>

                    <div style={{display:this.state.ColorPicker3 ? "block" : "none"}} className="cover" onClick={this.handleUnfocus3}/>
                  <label className={this.state.ColorPicker3 ? "lblcp hl" : "lblcp"}>
                    Cor background botão:
                    <input type="text" value={this.state.Color3} onChange={this.handleMChangeColor3} onClick={this.handleFocus3}/>
                    <div style={{display:this.state.ColorPicker3 ? "block" : "none"}} className="colorpicker">
                      <ChromePicker color={this.state.Color3} onChangeComplete={this.handleChangeColor3} disableAlpha={true} />
                    </div>
                  </label>

                    <div style={{display:this.state.ColorPicker4 ? "block" : "none"}} className="cover" onClick={this.handleUnfocus4}/>
                  <label className={this.state.ColorPicker4 ? "lblcp hl" : "lblcp"}>
                    Cor texto botão:
                    <input type="text" value={this.state.Color4} onChange={this.handleMChangeColor4} onClick={this.handleFocus4}/>
                    <div style={{display:this.state.ColorPicker4 ? "block" : "none"}} className="colorpicker">
                      <ChromePicker color={this.state.Color4} onChangeComplete={this.handleChangeColor4} disableAlpha={true} />
                    </div>
                  </label>
                </div>
              </label>
            </div>
        </div>
        <div className="containerhead">
          <div className="headcat" id="head4"><div className="numcat">4</div>Saber mais</div>
            <div className="conteudo cradio" id="cont4">
            <label className="iradio"><input type="radio" value="false" checked={this.state.selectedOption4 === "false"} onChange={this.handleChange4}/><span>Link default</span></label>
            <label className="iradio">
              <input type="radio" value="true" checked={this.state.selectedOption4 === "true"} onChange={this.handleChange4}/>
              <span>Link Custom</span>
              <input type="text" value={this.state.Link} onChange={this.handleChangeLink}/>
            </label>
            </div>
        </div>
        <div className="containerhead">
          <div className="headcat" id="head5"><div className="numcat">5</div>Tipo de conformidade</div>
            <div className="conteudo cradio" id="cont5">
              <label className="iradio"><input type="radio" value="1" checked={this.state.selectedOption5 === '1'} onChange={this.handleChange5}/><span>Apenas informar os utilizadores sobre o uso das cookies</span></label>
              <label className="iradio"><input type="radio" value="2" checked={this.state.selectedOption5 === '2'} onChange={this.handleChange5}/><span>Dar opção de opt-out das cookies (Advanced)</span></label>
              <label className="iradio"><input type="radio" value="3" checked={this.state.selectedOption5 === '3'} onChange={this.handleChange5}/><span>Dar opção de opt-in das cookies (Advanced)</span></label>
            </div>
        </div>
        <div className="containerhead final">
          <div className="headcat" id="head6"><div className="numcat">6</div>Texto Customizado</div>
            <div className="conteudo cradio" id="cont6">
              <label className="iradio CustomText">
                <input type="checkbox" checked={this.state.selectedOption6 === "true"} onChange={this.handleChange6}/>
                <span className="CTH">Texto Customizado</span>
                <div className="CTtxt">
                  <label><span>Mensagem</span><input type="text" value={this.state.CustomText1} onChange={this.handleChangeText1} placeholder="Mensagem"/></label>
                  <label><span>Texto do botão de Fechar</span><input type="text" value={this.state.CustomText2} onChange={this.handleChangeText2} placeholder="Texto do botão de Fechar"/></label>
                  <label><span>Texto da Política de Privacidade</span><input type="text" value={this.state.CustomText3} onChange={this.handleChangeText3} placeholder="Texto da Política de Privacidade"/></label>
                  <label id="labelmisc"><span>Misc</span><input type="text" value={this.state.CustomText4} onChange={this.handleChangeText4} placeholder="Misc"/></label>
                </div>
              </label>
            </div>
        </div>

        </div>
        <div className="container">
          Código:<br/>
          <code><span id="codigo"/></code><br/>
          <div className="divbotoes">
            <Clipboard data-clipboard-target="#codigo" className="botao-copiar-codigo"> Copiar código </Clipboard>
            <a className="botao-copiar-codigo" href="assets/assets.zip"> Download assets </a>
          </div>
          <div id="aviso"/>
        </div>
      </div>
      </div>
    );
  }



}


export default App;


window.addEventListener("load", function(){
  zAtualizar();
  jquery();
});

function jquery() {
  for(var i=1;i<=6;i++){$("#cont"+i).hide();}
    $("#head1").click(function(){
      if($(this).hasClass("open")) {
        $(this).removeClass('open');
        $("#cont1").slideUp();
      } else {
        $(".open").removeClass("open");
        $(this).addClass("open");
        $(".conteudo").slideUp();
        $("#cont1").slideToggle();
      }
    });
    $("#head2").click(function(){
      if($(this).hasClass("open")) {
        $(this).removeClass('open');
        $("#cont2").slideUp();
      } else {
        $(".open").removeClass("open");
        $(this).addClass("open");
        $(".conteudo").slideUp();
        $("#cont2").slideToggle();
      }
    });
    $("#head3").click(function(){
      if($(this).hasClass("open")) {
        $(this).removeClass('open');
        $("#cont3").slideUp();
      } else {
        $(".open").removeClass("open");
        $(this).addClass("open");
        $(".conteudo").slideUp();
        $("#cont3").slideToggle();
      }
    });
    $("#head4").click(function(){
      if($(this).hasClass("open")) {
        $(this).removeClass('open');
        $("#cont4").slideUp();
      } else {
        $(".open").removeClass("open");
        $(this).addClass("open");
        $(".conteudo").slideUp();
        $("#cont4").slideToggle();
      }
    });
    $("#head5").click(function(){
      if($(this).hasClass("open")) {
        $(this).removeClass('open');
        $("#cont5").slideUp();
      } else {
        $(".open").removeClass("open");
        $(this).addClass("open");
        $(".conteudo").slideUp();
        $("#cont5").slideToggle();
      }
    });
    $("#head6").click(function(){
      if($(this).hasClass("open")) {
        $(this).removeClass('open');
        $("#cont6").slideUp();
      } else {
        $(".open").removeClass("open");
        $(this).addClass("open");
        $(".conteudo").slideUp();
        $("#cont6").slideToggle();
      }
    });

}


function zAtualizar() {
  var tab="  "

  var inicio= '<link rel="stylesheet" type="text/css" href="'+linkcss+'"/>\n' +
      '<script src="'+linkjs+'"></script>\n' +
      '<script>\n' +
      'window.addEventListener("load", function(){\n' +
      'window.cookieconsent.initialise({\n'


  var palette= tab+tab+'"palette": {\n'

  var popup= tab+tab+tab+'"popup": {\n'
  var popupelemento = new Array()
  popupelemento[0]=tab+tab+tab+tab+'"background": "#000"\n'
  popupelemento[1]=""

  var popupfim=tab+tab+tab+'},\n'

  var button=tab+tab+tab+'"button": {\n'

  var btnelemento = new Array()

  btnelemento[0]=tab+tab+tab+tab+'"background": "#f1d600"\n'
  btnelemento[1]=""
  btnelemento[2]=""

  var btnfim=tab+tab+tab+'}\n'

  var fimpalette =tab+tab+'}'

  var position="";
  var theme="";
  var showLink="";
  var type="";

  var content=tab+'"content":{\n'
  var contentElemento= new Array()
  contentElemento[0]=""
  contentElemento[1]=""
  contentElemento[2]=""
  contentElemento[3]=""
  contentElemento[4]=""
  var fimcontent = tab+'}\n'

  var fim='})});\n' +
          '</script>\n'

      //debug settings

      if(false) {
        console.log("*********************************")
        console.log("| Settings[1]="+Settings[1])
        console.log("| Settings[2]="+Settings[2])
        console.log("| Settings[3]="+Settings[3])
        console.log("| Settings[4]="+Settings[4])
        console.log("| Settings[5]="+Settings[5])
        console.log("| Settings[6]="+Settings[6])
        console.log("*********************************")
      }

      //debug cores

      if(false) {
        for(var i=1;i<Cores.length;i++) {
          if(Cores[i]!=undefined) {
            console.log("*********************")
            console.log("| Cores["+i+"][0]="+Cores[i][0])
            console.log("| Cores["+i+"][1]="+Cores[i][1])
            console.log("| Cores["+i+"][2]="+Cores[i][2])
            console.log("| Cores["+i+"][3]="+Cores[i][3])
            console.log("*********************")
          } else {console.log(i+" Falhou")}
        }
      }

      //settings
      //Position
      switch(Settings[1]) {
        case "2":
          position=tab+'"position": "bottom-left"'
          break;
        case "3":
          position=tab+'"position": "top"'
          break;
        case "4":
          position=tab+'"position": "bottom-right"'
          break;
        case "5":
          position=tab+'"position": "top",\n'+tab+'"static": true'
          break;
        default:
          position=""
      }

      //Palette


      if(Cores[Settings[3]][1]!="") {
        popupelemento[0]=tab+tab+tab+tab+'"background": "'+Cores[Settings[3]][0]+'",\n'
        popupelemento[1]=tab+tab+tab+tab+'"text": "'+Cores[Settings[3]][1]+'"\n'
      } else {popupelemento[0]=tab+tab+tab+tab+'"background": "'+Cores[Settings[3]][0]+'"\n'}

      if(Cores[Settings[3]][3]!="") {
        btnelemento[0]=tab+tab+tab+tab+'"background":"'+Cores[Settings[3]][2]+'",\n'
        btnelemento[1]=tab+tab+tab+tab+'"text":"'+Cores[Settings[3]][3]+'"\n'
      } else {btnelemento[0]=tab+tab+tab+tab+'"background":"'+Cores[Settings[3]][2]+'"\n'}


      //Layout
      if(Settings[2]==2){theme=tab+'"theme":"edgeless"'}
      else if(Settings[2]==3){theme=tab+'"theme":"classic"'}

      if(Settings[2]==4){
        btnelemento[0]=tab+tab+tab+tab+'"background": "transparent",\n'
        btnelemento[1]=tab+tab+tab+tab+'"text":"'+Cores[Settings[3]][2]+'",\n'
        btnelemento[2]=tab+tab+tab+tab+'"border":"'+Cores[Settings[3]][2]+'"\n'
      }

      //learn more
      if(Settings[4]=="true" && link=="") {
        showLink=tab+'"showLink": false'
      } else if(Settings[4]=="true" && link!="") {contentElemento[4]=tab+tab+'"href": "'+link+'"\n'}

      //Compliance type
      if(Settings[5]==2) {
        type=tab+'"type": "opt-out"'
      } else if(Settings[5]==3) {type=tab+'"type": "opt-in"'}

      //Custom text
      if(Settings[6]=="true"){
        if(TextoCustom[0]!="") {contentElemento[0]=tab+tab+'"message": "'+TextoCustom[0]+'"'}
        if(TextoCustom[1]!="") {contentElemento[1]=tab+tab+'"dismiss": "'+TextoCustom[1]+'"'}
        if(TextoCustom[2]!="") {contentElemento[2]=tab+tab+'"link": "'+TextoCustom[2]+'"'}
        if(TextoCustom[3]!="") {
          if(Settings[5]==2) {contentElemento[3]=tab+tab+'"deny": "'+TextoCustom[3]+'"'}
          if(Settings[5]==3) {contentElemento[3]=tab+tab+'"allow": "'+TextoCustom[3]+'"'}
        }
      }

      if(contentElemento[0]!="" && contentElemento[1]=="" && contentElemento[2]=="" && contentElemento[3]=="" && contentElemento[4]=="") {
        contentElemento[0]+="\n"
      } else {if(contentElemento[0]!=""){contentElemento[0]+=",\n"}}

      if(contentElemento[1]!="" && contentElemento[2]=="" && contentElemento[3]=="" && contentElemento[4]=="") {
        contentElemento[1]+="\n"
      } else {if(contentElemento[1]!=""){contentElemento[1]+=",\n"}}

      if(contentElemento[2]!="" && contentElemento[3]=="" && contentElemento[4]=="") {
        contentElemento[2]+="\n"
      } else {if(contentElemento[2]!=""){contentElemento[2]+=",\n"}}

      if(contentElemento[3]!="" && contentElemento[4]=="") {
        contentElemento[3]+="\n"
      } else {if(contentElemento[3]!=""){contentElemento[3]+=",\n"}}

      //Juntar o content para passar corretamente pelo check de virgulas
      if(contentElemento[0]!="" || contentElemento[1]!="" || contentElemento[2]!="" || contentElemento[3]!="" || contentElemento[4]!="")
        {content=content+contentElemento[0]+contentElemento[1]+contentElemento[2]+contentElemento[3]+contentElemento[4]+fimcontent}
      else {content=""}

      //Virgulas
      //position
      if(position!="" && theme=="" && showLink=="" && type=="" && content=="") {
        position+="\n"
      } else {if(position!=""){position+=",\n"}}

      //theme
      if(theme!="" && showLink=="" && type=="" && content=="") {
        theme+="\n"
      } else {if(theme!=""){theme+=",\n"}}

      //showLink
      if(showLink!="" && type=="" && content=="") {
        showLink+="\n"
      } else  {if(showLink!=""){showLink+=",\n"}}

      //Compliance Type
      if(type!="" && content=="") {
        type+="\n"
      } else  {if(type!=""){type+=",\n"}}

      if(position=="" && showLink=="" && theme=="" && type=="" && content=="") {
        fimpalette+="\n"
      } else {fimpalette+=",\n"}

      popup=popup+popupelemento[0]+popupelemento[1]+popupfim
      button=button+btnelemento[0]+btnelemento[1]+btnelemento[2]+btnfim

    var elemento=inicio+palette+popup+button+fimpalette+position+theme+showLink+type+content+fim
    const element=elemento
  ReactDOM.render(element, document.getElementById('codigo'));
  if(Settings[5]!=1) {
    var aviso= 'onInitialise: function (status) {\n'
             + tab+'var type = this.options.type;\n'
             + tab+'var didConsent = this.hasConsented();\n'
             + tab+'if (type == \'opt-in\' && didConsent) {\n'
             + tab+tab+'// enable cookies\n'
             + tab+'}\n'
             + tab+'if (type == \'opt-out\' && !didConsent) {\n'
             + tab+tab+'// disable cookies\n'
             + tab+'}\n'
             + '},\n\n'
             + 'onStatusChange: function(status, chosenBefore) {\n'
             + tab+'var type = this.options.type;\n'
             + tab+'var didConsent = this.hasConsented();\n'
             + tab+'if (type == \'opt-in\' && didConsent) {\n'
             + tab+tab+'// enable cookies\n'
             + tab+'}\n'
             + tab+'if (type == \'opt-out\' && !didConsent) {\n'
             + tab+tab+'// disable cookies\n'
             + tab+'}\n'
             + '},\n\n'
             + 'onRevokeChoice: function() {\n'
             + tab+'var type = this.options.type;\n'
             + tab+'if (type == \'opt-in\') {\n'
             + tab+tab+'// disable cookies\n'
             + tab+'}\n'
             + tab+'if (type == \'opt-out\') {\n'
             + tab+tab+'// enable cookies\n'
             + tab+'}\n'
             + '},'
      const warning= (<div><span className="avisoH">Se utilizar um tipo de conformidade avançado irá necessitar de isto</span><div className="aviso">{aviso}</div></div>)
      ReactDOM.render(warning, document.getElementById("aviso"));
  }
  else {
    const empty = <div/>
    ReactDOM.render(empty,document.getElementById("aviso"))
  }
  Cookie.remove("cookieconsent_status");

  if(content=="") {
    content=',"content":{'
    contentElemento[0]='"message": "Este website usa cookies para assegurar que tenha a melhor experiencia no nosso website",'
    contentElemento[1]='"dismiss": "Fechar",'
    contentElemento[2]='"link": "Saber mais",'
    contentElemento[3]='"deny":"Rejeitar","allow":"Aceitar e continuar",'
    contentElemento[4]='"href":"http://lmgtfy.com/?q=dogs"'
    fimcontent = '}'
    content = content+contentElemento[0]+contentElemento[1]+contentElemento[2]+contentElemento[3]+contentElemento[4]+fimcontent
  }

  var opcoesjson="{"+palette+popup+button+fimpalette+position+theme+showLink+type+content+"}"
  opcoesjson=opcoesjson.replace(/\\n/g,"")
  var options =JSON.parse(opcoesjson)
  draw(options)

  switch(Settings[5]) {
    case "1":
      $("#labelmisc").hide();
      break;
    case "2":
      $("#labelmisc").show();
      $("#labelmisc span").html("Mensagem de rejeitar");
      $("#labelmisc input").attr("placeholder", "Mensagem de rejeitar");
      break;
    case "3":
      $("#labelmisc").show();
      $("#labelmisc span").html("Mensagem de permitir");
      $("#labelmisc input").attr("placeholder", "Mensagem de permitir");
      break;
    default:
      // console.log("erro");
      $("#labelmisc").hide();
  }


}

var ccName

  function draw(options) {
    // fix to a stupid bug, that only affects configurator
    options.elements = {messagelink : '<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="{{href}}" target="_blank">{{link}}</a></span>'};
    function openCC() {
        window.cookieconsent.initialise(options, function (popup) {
            ccName = popup.open();
        });
    }
    if (!ccName) {
        openCC();
    }
    else {
        ccName.destroy();
        openCC();
    }
}
function criarArray(length) {
    var arr = new Array(length || 0),
        i = length;

    if (arguments.length > 1) {
        var args = Array.prototype.slice.call(arguments, 1);
        while(i--) arr[length-1 - i] = criarArray.apply(this, args);
    }

    return arr;
}

function criarPalette(index,BGpopup,TXTpopup,BGbutton,TXTbutton) {
  Cores[index][0]=BGpopup
  Cores[index][1]=TXTpopup
  Cores[index][2]=BGbutton
  Cores[index][3]=TXTbutton
}




// WEBPACK FOOTER //
// ./src/App.js